export const types = {
  SET_CLIENT_SESSIONS: 'SET_CLIENT_SESSIONS',
};
